import React, { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { CaroIcon } from '../../../common/components/CaroIcon';
import { selectOnlineAgent } from '../../../common/selectors/header';
import { hasContent } from '../../../util/guards';
import s from './styles.scss';

export const Avatar: FC = () => {
  const [imageError, setImageError] = useState(false);
  const agent = useSelector(selectOnlineAgent);

  const onError = useCallback(() => setImageError(true), []);

  if (agent && hasContent(agent.profileImage) && !imageError) {
    return (
      <img
        className={s.avatar}
        src={agent.profileImage}
        onError={onError}
        width="32"
        height="32"
        alt=""
      />
    );
  }

  return <CaroIcon size={32} className={s.avatar} />;
};
